import { useEffect, useState } from 'react';
import './Formfillingcont.css'; 
import api from '../jobsite/Components/api.js';
import { useNavigate } from 'react-router-dom';
let Formfillingcont=(props)=>{  
    let navigate = useNavigate();
    let [applicants, setapplicants]=useState(null);
    let [link, setlink]= useState(null); 
    let [searchval, setsearchval]= useState(null);
    let [imgsrc, setimgsrc]=useState(null);
    
     

    useEffect(()=>{
        let login = localStorage.getItem("login");
        if(login===null){
            navigate("/forms-filler-comp");
        }
        getallapplicantsdetals();

    },[]); 
    let getallapplicantsdetals =async()=>{
        const resp = await api.get("/Getapplicantsalldetails.php");
        setapplicants(resp.data.data);
    } 
    let searchinpchangehandel=(e)=>{
        setsearchval(e.target.value);
    }
    let searchbtn=()=>{
        setlink(searchval);

    }
    
    let clickonimage=(e)=>{ 
        setimgsrc(e.target.src);
        document.querySelector(".clickimgcont").style.display="block";

    }
    let hidedocumntpop=()=>{
        document.querySelector(".clickimgcont").style.display="none";

    }
    let logoutbb=()=>{
        localStorage.setItem("login", "");
        localStorage.setItem("loginstatus", "loogedout successfully");
        navigate("/forms-filler-comp");   
     }
    let [id, setid]=useState(null);
      let [name , setname]=useState(null);
      let [fathername , setfathername]=useState(null);
      let [mothername , setmothername]=useState(null);
      let [dob , setdob]=useState(null);
      let [mobilenum , setmobilenum]=useState(null);
      let [altnum , setaltnum]=useState(null);
      let [emailid , setemailid]=useState(null);
      let [hnum , sethnum]=useState(null);
      let [vill , setvill]=useState(null);
      let [post , setpost]=useState(null);
      let [thana , setthana]=useState(null);
      let [dist , setdist]=useState(null);
      let [state , setstate]=useState(null);
      let [pincode , setpincode]=useState(null);
      let [height , setheight]=useState(null);
      let [weight , setweight]=useState(null);
      let [chest , setChest]=useState(null);
      let [PwPD , setPwPD]=useState(null);
      let [mark1 , setmark1]=useState(null);
      let [mark2 , setmark2]=useState(null);
     let [type , settype]=useState(null);  
     let editapplicantdetails=(e)=>{
         setid(e.id);
        setname(e.applicantname)
        setfathername(e.fathername)
        setmothername(e.mothername)
        setdob(e.dob)
        setmobilenum(e.mobilenum)
        setaltnum(e.altnum)
        setemailid(e.emailid)
        sethnum(e.hnum)
        setvill(e.village)
        setpost(e.postoffice)
        setthana(e.thana)
        setdist(e.thana)
        setstate(e.state)
        setpincode(e.pincode)
        setweight(e.weight)
        setheight(e.height)
        setChest(e.chest)
        setPwPD(e.PwPD)
        setmark1(e.markone)
        setmark2(e.marktwo)  
        document.querySelector(".updateappdetcont").style.display="block";
      

        
     }
     let updatedetailsfun=async()=>{
        let applidetailsformdata = new FormData();
        applidetailsformdata.append("id", id);
        applidetailsformdata.append("name", name);
        applidetailsformdata.append("fathername", fathername);
        applidetailsformdata.append("mothername",mothername);
        applidetailsformdata.append("dob", dob);
        applidetailsformdata.append("mobnum", mobilenum);
        applidetailsformdata.append("emailid", emailid);
        applidetailsformdata.append("altnum", altnum);
        applidetailsformdata.append("hnum", hnum);
        applidetailsformdata.append("vill", vill);
        applidetailsformdata.append("postofic", post);
        applidetailsformdata.append("thana", thana);
        applidetailsformdata.append("dist", dist);
        applidetailsformdata.append("state", state);
        applidetailsformdata.append("pincode", pincode);
        applidetailsformdata.append("height", height);
        applidetailsformdata.append("weight", weight);
        applidetailsformdata.append("chest", chest);
        applidetailsformdata.append("pwpd", PwPD);
        applidetailsformdata.append("mark1", mark1);
        applidetailsformdata.append("mark2", mark2);
        const resp =await api.post("/updateapplicantsdetails.php", applidetailsformdata)
        console.log(resp.data);
        props.Successandrerrorfun(resp.data.result,"");
        document.querySelector(".updateappdetcont").style.display="none";
        getallapplicantsdetals();
     }



     let unhideupdatecont=(w)=>{
        settype(w);
        document.querySelector(".docupdatecont").style.display="block"; 
     }

    
    
    let [inpdocreq, setinpdocreq]= useState(null);
    let [docreqall, setdocreqall]= useState(null);
    let inputtypefilechanhandel=(event)=>{  
        let name=event.target.name;
        let value =(URL.createObjectURL(event.target.files[0])); 
        let valuee =event.target.files[0]; 

        setinpdocreq(values =>({...values, [name]: value}));
        setdocreqall(values =>({...values, [name]: valuee}));

    } 
    let updatedofun=async(e)=>{
        e.preventDefault();
        let docform = new FormData();
        docform.append('type', type);
        docform.append('id', applicants.id);
        docform.append('document', docreqall?.photos);
        console.log(docform);
        const resp = await api.post("/updatedocument.php", docform);
        console.log(resp.data);
        props.Successandrerrorfun(resp.data.result, "");
        document.querySelector(".docupdatecont").style.display="none";
        getallapplicantsdetals();
    }
   
    
    
    return( 
        <div className='formfillingmaincontt'>
            <div style={{display:"none"}} className='updateappdetcont'>
                <p className='closecont'><span style={{cursor:"pointer" , padding:"10px", fontSize:"20px"}} onClick={()=>{document.querySelector(".updateappdetcont").style.display="none";}}>X</span></p>
                <div className='submaincont'>
                    <p>Personal Details</p>
                    <input value={name} onChange={(e)=>{setname(e.target.value)}} placeholder='Name' type='text'/>
                    <input onChange={(e)=>{setfathername(e.target.value)}} value={fathername} placeholder='Father Name' type='text'/>
                    <input onChange={(e)=>{setmothername(e.target.value)}} placeholder='Mother Name' value={mothername} type='text'/>
                    <input onChange={(e)=>{setdob(e.target.value)}} value={dob} placeholder='Date Of Birth' type='text'/>
                </div>
                <div className='submaincont'>
                    <p>Contact Details</p>
                    <input onChange={(e)=>{setmobilenum(e.target.value)}} value={mobilenum} placeholder='Mobile Number' type='text'/>
                    <input value={emailid} placeholder='Email ID' onChange={(e)=>{setemailid(e.target.value)}} type='text'/>
                    <input onChange={(e)=>{setaltnum(e.target.value)}}  value={altnum} placeholder='Alternate Number' type='text'/>
                </div>
                <div className='submaincont'>
                    <p>Address Details</p>
                    <input onChange={(e)=>{sethnum(e.target.value)}}  value={hnum} placeholder='House no' type='text'/>
                    <input onChange={(e)=>{setvill(e.target.value)}}   value={vill} placeholder='Village' type='text'/>
                    <input  onChange={(e)=>{setpost(e.target.value)}} value={post} placeholder='postOffice' type='text'/>
                    <input onChange={(e)=>{setthana(e.target.value)}}  value={thana} placeholder='Police Station' type='text'/>
                    <input onChange={(e)=>{setdist(e.target.value)}}  value={dist} placeholder='District' type='text'/>
                    <input onChange={(e)=>{setstate(e.target.value)}} value={state} placeholder='State' type='text'/>
                    <input onChange={(e)=>{setpincode(e.target.value)}} value={pincode} placeholder='Pin Code' type='text'/>
                </div> 
                <div className='submaincont'>
                    <p>Physical Details</p>
                    <input  onChange={(e)=>{setheight(e.target.value)}} value={height} placeholder='Height' type='text'/>
                    <input onChange={(e)=>{setweight(e.target.value)}} value={weight} placeholder='Weight' type='text'/>
                    <input onChange={(e)=>{setChest(e.target.value)}} value={chest} placeholder='Chest' type='text'/>
                    <input onChange={(e)=>{setPwPD(e.target.value)}} value={PwPD} placeholder='PwPD' type='text'/>
                </div>
                 
               <div className='submaincont'>
                    <p>Physical Identification Details</p>
                    <input onChange={(e)=>{setmark1(e.target.value)}} value={mark1} placeholder='Identification Mark 1' type='text'/>
                    <input onChange={(e)=>{setmark2(e.target.value)}} value={mark2} placeholder='Identification Mark 2' type='text'/>
                </div>
                <p style={{textAlign:"center"}}><button style={{backgroundColor:"lightgreen", border:"none", fontSize:"20px", padding:"5px 10px", borderRadius:"5px"}} onClick={updatedetailsfun}>Update Details</button></p>
            </div>
             <form onSubmit={updatedofun} style={{display:"none"}} className='docupdatecont'>
                <p className='closecont'><span onClick={()=>{document.querySelector(".docupdatecont").style.display="none";}} style={{cursor:"pointer"}}>X</span></p>
                <div  className='inpimgcont'>
                    <label htmlFor='doc'>Choose File/Photo</label>
                    <input id='doc' style={{display:"none"}} name='photos' onChange={(e)=>{inputtypefilechanhandel(e)}} type='file'/>
                    <img src={inpdocreq?.photos}/>
                    <input className='subbtn' type='submit'/>
                </div>
                
            </form>
            <div style={{display:"none"}} className='clickimgcont'>
                <p onClick={hidedocumntpop} className='hideimage'>x</p>
                <img alt='popimg' className='popimage' src={imgsrc}/>
            </div>
            <h2  className='welcomeheading'>Welcome: {applicants?.applicantname}<button className='backbtn' onClick={logoutbb}>logout</button></h2>
            <div className='notediv'>
                <p className='noteptag'>*Do not refresh page</p>
                <p className='noteptag'>*If shows refuse to connect on link <a target='_blank' rel='noreferrer' href='https://chromewebstore.google.com/detail/ignore-x-frame-headers/gleekbfjekiniecknbkamfmkohkpodhe?pli=1'>click hare</a> and add extention to your browser</p> 

            </div> 
            <div className='formfillingmaincont'> 
                <div className='leftcont smstyl'> 
                    <div className='personaldetcont'>
                        <h3 className='perdetheading'>Personal Details</h3>
                        <p className='ptagdetcont'>
                            <span>Name</span>
                             <span>{applicants?.applicantname}</span> 
                            
                        </p>
                        <p className='ptagdetcont'>
                            <span>FatherName</span>
                            <span>{applicants?.fathername}</span>
                        </p>
                        <p className='ptagdetcont'>
                            <span>MotherName</span>
                            <span>{applicants?.mothername}</span>
                        </p>
                        <p className='ptagdetcont'> 
                            <span>Date Of Birth</span>
                            <span>{applicants?.dob}</span>
                        </p>
                    </div>
                    <div className='personaldetcont'>
                        <h3 className='perdetheading'>Contact Details</h3>
                        <p className='ptagdetcont'>
                            <span>Mobile Number</span>
                            <span>{applicants?.mobilenum}</span>
                        </p>
                        <p className='ptagdetcont'>
                            <span>Email-Id</span>
                            <span>{applicants?.emailid}</span>
                        </p>
                        <p className='ptagdetcont'>
                            <span>Alternate Number</span>
                            <span>{applicants?.altnum}</span>
                        </p>
                    </div>
                    <div className='personaldetcont'>
                        <h3 className='perdetheading'>Address Details</h3>
                        <p className='ptagdetcont'>
                            <span>House No</span>
                            <span>{applicants?.hnum}</span>
                        </p>
                        <p className='ptagdetcont'>
                            <span>Village</span>
                            <span>{applicants?.village}</span>
                        </p>
                        <p className='ptagdetcont'>
                            <span>Thana</span>
                            <span>{applicants?.thana}</span>
                        </p>
                        <p className='ptagdetcont'>
                            <span>Post Office</span>
                            <span>{applicants?.postoffice}</span>
                        </p>
                        <p className='ptagdetcont'>
                            <span>District</span>
                            <span>{applicants?.district}</span>
                        </p>
                        <p className='ptagdetcont'>
                            <span>State</span>
                            <span>{applicants?.state}</span>
                        </p>
                        <p className='ptagdetcont'>
                            <span>Pin Code</span>
                            <span>{applicants?.pincode}</span>
                        </p>
                    </div>
                    <div className='personaldetcont'>
                        <h3 className='perdetheading'>Physical Details</h3>
                        <p className='ptagdetcont'>
                            <span>Height</span>
                            <span>{applicants?.height}</span>
                        </p>
                        <p className='ptagdetcont'>
                            <span>Weight</span>
                            <span>{applicants?.weight}</span>
                        </p>
                        <p className='ptagdetcont'>
                            <span>Chest</span>
                            <span>{applicants?.chest}</span>
                        </p>
                        <p className='ptagdetcont'>
                            <span>PwPD</span>
                            <span>{applicants?.PwPD}</span>
                        </p>
                    </div>
                    <div className='personaldetcont'>
                        <h3 className='perdetheading'>Physical Identification Details</h3>
                        <p className='ptagdetcont'>
                            <span>*1</span>
                            <span>{applicants?.markone}</span>
                        </p>
                        <p className='ptagdetcont'>
                            <span>*2</span>
                            <span>{applicants?.marktwo}</span>
                        </p>
                    </div>
                    <div className='personaldetcont'>
                        <h3 className='perdetheading'>Documents</h3>
                        {
                            applicants?.photo !== "" ? <p className='ptagdetcont'>
                            <img alt='popimg' onClick={clickonimage} width="150" height="150" src={"https://makeeasyway.in/jobSiteData/"+applicants?.photo}/>
                             <i onClick={()=>{unhideupdatecont("photo")}} title='photo' className='bx bx-edit-alt'></i>
                        </p> : ""
                        }
                        {
                            applicants?.sign !== "" ?  <p className='ptagdetcont'>
                            <img alt='popimg' onClick={clickonimage} width="150" height="150" src={"https://makeeasyway.in/jobSiteData/"+applicants?.sign}/>
                             <i onClick={()=>{unhideupdatecont("sign")}} title='Sign' class='bx bx-edit-alt'></i>

                            </p> : ""
                        }
                        {
                            applicants?.tenth !== "" ? <p className='ptagdetcont'>
                            <img alt='popimg' onClick={clickonimage} width="150" height="150" src={"https://makeeasyway.in/jobSiteData/"+applicants?.tenth}/>
                            <i onClick={()=>{unhideupdatecont("tenth")}} title='tenth' class='bx bx-edit-alt'></i>
                            </p> : ""
                        }






                        {
                            applicants?.aadharcard !== "" ? <p className='ptagdetcont'>
                            <img alt='popimg' onClick={clickonimage} width="150" height="150" src={"https://makeeasyway.in/jobSiteData/"+applicants?.aadharcard}/>
                            <i onClick={()=>{unhideupdatecont("aadharcard")}} title='Aadhar card' class='bx bx-edit-alt'></i>
                            </p> : ""
                       }

                       {
                            applicants?.pancard !== "" ? <p className='ptagdetcont'>
                            <img alt='popimg' onClick={clickonimage} width="150" height="150" src={"https://makeeasyway.in/jobSiteData/"+applicants?.pancard}/>
                            <i onClick={()=>{unhideupdatecont("pancard")}} title='Pan card' class='bx bx-edit-alt'></i>
                            </p> : ""
                       }




                       {
                            applicants?.twelthcth !== "" ? <p className='ptagdetcont'>
                            <img alt='popimg' onClick={clickonimage} width="150" height="150" src={"https://makeeasyway.in/jobSiteData/"+applicants?.twelthcth}/>
                            <i onClick={()=>{unhideupdatecont("twelthcth")}} title='12th' class='bx bx-edit-alt'></i>
                            </p> :""
                       }
                       
                       {
                            applicants?.underpostgraduation !== "" ? <p className='ptagdetcont'>
                            <img alt='popimg' onClick={clickonimage} width="150" height="150" src={"https://makeeasyway.in/jobSiteData/"+applicants?.underpostgraduation}/>
                            <i onClick={()=>{unhideupdatecont("underpostgraduation")}} title='Graduation/Under' class='bx bx-edit-alt'></i>
                            </p> : ""
                       }
                       
                       {
                            applicants?.cast !== "" ?<p className='ptagdetcont'>
                            <img alt='popimg' onClick={clickonimage} width="150" height="150" src={"https://makeeasyway.in/jobSiteData/"+applicants?.cast}/>
                            <i onClick={()=>{unhideupdatecont("cast")}} title='Cast' class='bx bx-edit-alt'></i>
                            </p> :""
                       }
                        
                    </div>
                    <p className='editapplicantsdetcont'>Edit applicant Details <span className='editapplicantdetbtn' onClick={()=>{editapplicantdetails(applicants)}}>Edit Details</span></p>
                </div> 
                <div className='rightcont smstyl'>
                    <div className='formfillcontmain'>
                        <h3 className='headingfillsec'>Enter Your Form link or website link to fill</h3>
                        <div className='searchandbuttoncont'>
                            <input onChange={searchinpchangehandel} type='search' className='searchinpt' placeholder='Enter your form link or website link'/>
                            <button onClick={searchbtn} className='srarchbtn'>Search</button>
                        </div>
                        <div className='iframecont'>
                            {
                                link !== "" ? <iframe
                                    className='formlinkndwebsite'
                                    src={link}
                                    width="100%"
                                    height="530"
                                    title="Example Iframe"
                            ></iframe> : "Link not available..!!! Enter form link at search bar"
                            }
                        </div>
                       
                        
                    </div>
                </div>
            </div>
          
        </div>
    );
}
export default Formfillingcont;